export enum EAppSearchResultsMode {
  MENU = 'menu',
  POPUP = 'popup',
}